export const COMMON_STYLES = {
  container: {
    backgroundColor: '#f5f7fa',
    p: 3,
    borderRadius: 2,
    border: '1px solid #e0e0e0',
    mt: 1.5,
  },
  gridItem: {
    xs: 12,
    md: 6,
  },
};

export const DEFAULT_PROPS = {
  disabled: false,
  size: 'small',
};

export const CURRENT_DATETIME_VALIDATION = {
  alias: {
    required: true,
    pattern: /^[a-zA-Z0-9_]{1,35}$/,
    message: 'Alias must be 1-35 alphanumeric characters',
  },
  'transformations.0.outputColumn': {
    required: true,
    validate: (value) => {
      if (!value || !/^[a-zA-Z0-9_]{1,35}$/.test(value)) {
        return 'Output column must be 1-35 alphanumeric characters';
      }
      return '';
    },
  },
};

export const COMMON_VALIDATION = {
  alias: {
    required: true,
    pattern: /^[a-zA-Z0-9_]{1,35}$/,
    message: 'Alias must be 1-35 alphanumeric characters',
  },
  'transformations.sourceColumns': {
    required: true,
    validate: (value) => {
      if (!value || !value[0]) {
        return 'At least one source column must be selected';
      }
      return '';
    },
  },
  'transformations.outputColumn': {
    validate: (value, transform) => {
      const shouldValidate = !transform?.transformInPlace;

      if (shouldValidate) {
        if (!value || !/^[a-zA-Z0-9_]{1,35}$/.test(value)) {
          return 'Output column must be 1-35 alphanumeric characters';
        }
      }

      return '';
    },
  },
};

export const COMMON_VALIDATION_SOURCE_COLUMN = {
  'transformations.sourceColumns': {
    required: true,
    validate: (value) => {
      if (!value || !value[0]) {
        return 'At least one source column must be selected';
      }
      return '';
    },
  },
};
export const COMMON_VALIDATION_PARAM = (message) => ({
  'transformations.param': {
    validate: (value) => {
      if (typeof value === 'string') {
        if (!value.trim()) {
          return message;
        }
      } else if (value === null || value === undefined) {
        return message;
      }
      return '';
    },
  },
});

export const COMMON_VALIDATION_ALIAS = {
  alias: {
    required: true,
    pattern: /^[a-zA-Z0-9_]{1,35}$/,
    message: 'Alias must be 1-35 alphanumeric characters',
  },
};

export const COMMON_VALIDATION_OUTPUT_COLUMN = {
  'transformations.outputColumn': {
    validate: (value, transform) => {
      const shouldValidate = !transform?.transformInPlace;

      if (shouldValidate) {
        if (!value || !/^[a-zA-Z0-9_]{1,35}$/.test(value)) {
          return 'Output column must be 1-35 alphanumeric characters';
        }
      }

      return '';
    },
  },
};
